/**
 * WordPress dependencies
 */
import {
	InnerBlocks,
} from '@wordpress/block-editor'
import {
	PanelBody,
	TextControl,
	RangeControl,
	ToggleControl 
} from '@wordpress/components'
import {
	addFilter,
	applyFilters
} from '@wordpress/hooks'
import { Fragment } from '@wordpress/element'
import { withSelect } from '@wordpress/data'
import { __ } from '@wordpress/i18n'
import {
	createHigherOrderComponent,
	compose
} from '@wordpress/compose'

/**
 * External dependencies
 */
import {
	ColumnControl,
	ImageControl
} from '~cartzillagb/components'
import classnames from 'classnames'
import i18n from 'cartzillagb'
import {
	withTabbedInspector,
	withUniqueClass
} from '~cartzillagb/higher-order'

const withCustomClassName = createHigherOrderComponent( BlockListBlock  => {
	return props => {
		if( ( props.attributes.smColumns || props.attributes.mdColumns || props.attributes.lgColumns ) && props.name === 'czgb/column'  ) {
			return <BlockListBlock { ...props } className={ `czgb-single-column m-0 col-sm-${ props.attributes.smColumns } col-md-${ props.attributes.mdColumns } col-lg-${ props.attributes.lgColumns } order-md-${props.attributes.order}` } />
		} 
		return <BlockListBlock { ...props } />
	}
}, 'withClientIdClassName' )

addFilter( 'editor.BlockListBlock', 'czgb/column', withCustomClassName )

addFilter( 'cartzillagb.column.edit.inspector.style.before', 'cartzillagb/column', ( output, props ) => {
	const { setAttributes, attributes } = props
	const {
		lgColumns,
		mdColumns,
		smColumns,
		columnId,
		backgroundImage,
		order,
		enableminheight,
		height,
	} = attributes

	return (
		<Fragment>
			<PanelBody title={ __( "Column Settings", i18n ) } initialOpen={ true }>
				<ColumnControl
					label={ __("Cloumn Width", i18n ) }
					lgColumns={ lgColumns }
					lgMin={ 1 }
					lgMax={ 12 }
					mdColumns={ mdColumns }
					mdMin={ 1 }
					mdMax={ 12 }
					smColumns={ smColumns }
					smMin={ 1 }
					smMax={ 12 }
					onChangelg={ value => setAttributes( { lgColumns: value } ) }
					onChangemd={ value => setAttributes( { mdColumns: value } ) }
					onChangesm={ value => setAttributes( { smColumns: value } ) }
				/>
				<RangeControl
					label={ __( 'Order Class', i18n ) }
					value={ order }
					onChange={ order => setAttributes( { order } ) }
					min={ 1 }
					max={ 12 }
				/>
			</PanelBody>
			
			<PanelBody title={ __( "Column ID", i18n ) } initialOpen={ true }>
				<TextControl
					label={ __('Enter ID', i18n ) }
					value={ columnId }
					onChange={ columnId => setAttributes( { columnId } ) }
				/>
			</PanelBody>
			<PanelBody title={ __( "Column Background", i18n ) } initialOpen={ true }>
				<ImageControl
					imageURL={ backgroundImage }
					onChange={ ( { url } ) => setAttributes( { backgroundImage: url } ) }
					onRemove={ () => { setAttributes( { backgroundImage: '' } ) } }
				/>
			</PanelBody>
			<PanelBody title={ __( "Column Height", i18n ) } initialOpen={ true }>
				<ToggleControl
					label={ __( 'Enable Minheight', i18n ) }
					checked={ enableminheight }
					onChange={ enableminheight => setAttributes( { enableminheight } ) }
				/>
				{ enableminheight &&
					<RangeControl
						label={ __( 'Min Height', i18n ) }
						value={ height }
						onChange={ height => setAttributes( { height } ) }
						min={ 10 }
						max={ 30 }
					/>
				}
			</PanelBody>
		</Fragment>
	)
} )

	
const edit = props => {
	const {
		className,
		attributes,
		hasChildBlocks,
	} = props

	const {
		height,
		columnId,
		backgroundImage,
	} = attributes

	const mainClasses = classnames( [
		'column',
		className,
	], applyFilters( 'cartzillagb.column.main-block.classes', {}, props ) )

	const htmlAttr = {}

		if( columnId !== '' ) {
			htmlAttr.id = columnId
		}

		if( backgroundImage ) {
			htmlAttr.style = {
				backgroundImage: "url(" + ( backgroundImage ) + ")",
				minHeight: `${ height }rem`,
			}
		}

	return (
		<div className={ mainClasses } { ...htmlAttr }>
			<InnerBlocks
				templateLock={ false }
				renderAppender={
					hasChildBlocks
						? undefined
						: () => <InnerBlocks.ButtonBlockAppender />
				}
			/>
		</div>
	)  
}

export default compose(
	withUniqueClass,
	withTabbedInspector( [ 'style', 'advanced' ] ),
	withSelect( ( select, ownProps ) => {
		const { clientId } = ownProps
		const { getBlockOrder } = select( 'core/block-editor' )

		return {
			hasChildBlocks: getBlockOrder( clientId ).length > 0,
		}
	} ),
)( edit )
